import React, { useContext } from "react";

import { AddButton } from "../utils/IconButton";
import { BarreSlot } from "../utils/PageEntete";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";

/* Outils d'une section (gabarit de la map) : sous-vues eventuelles et « + » rond.
 * Dans la page Configuration, ils montent dans la barre de puces (BarreSlot) : pas de
 * ligne d'en-tete entre la barre et le tableau. Le titre, qui repete la puce active,
 * est masque a l'ecran et garde pour l'accessibilite. */
function SettingsHeader({ title, onAdd, children }) {
  const slot = useContext(BarreSlot);
  const heading = <h2 className="cti-sr-only">{title}</h2>;
  const tools = (children || onAdd) && (
    <>
      {children && <span className="cti-sep" />}
      {children}
      {onAdd && <AddButton onClick={onAdd} />}
    </>
  );
  if (!tools) return heading;
  if (slot) {
    return (
      <>
        {heading}
        {createPortal(tools, slot)}
      </>
    );
  }
  return (
    <div className="cti-panel-head">
      {heading}
      {tools}
    </div>
  );
}

SettingsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onAdd: PropTypes.func,
  children: PropTypes.node,
};

export default SettingsHeader;
